import * as React from 'react';

var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
var SvgBinMid = function SvgBinMid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.75 5C2.33579 5 2 5.33579 2 5.75C2 6.16421 2.33579 6.5 2.75 6.5H4.04683L4.88083 19.4271C4.97419 20.8741 6.17508 22 7.62513 22H16.3749C17.8249 22 19.0258 20.8741 19.1192 19.4271L19.9531 6.5H21.25C21.6642 6.5 22 6.16421 22 5.75C22 5.33579 21.6642 5 21.25 5H19.25H16.417C15.7203 3.243 14.0061 2 12 2C9.99396 2 8.27977 3.243 7.58302 5H4.75H2.75ZM7.62513 20.5H16.3749C17.034 20.5 17.5798 19.9882 17.6223 19.3305L18.4501 6.5H5.54994L6.37772 19.3305C6.42015 19.9882 6.96601 20.5 7.62513 20.5ZM14.7393 5C14.1616 4.09775 13.1501 3.5 12 3.5C10.85 3.5 9.83844 4.09775 9.2607 5H14.7393Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 10.75C10.5 10.3358 10.1642 10 9.75 10 9.33579 10 9 10.3358 9 10.75V16.25C9 16.6642 9.33579 17 9.75 17 10.1642 17 10.5 16.6642 10.5 16.25V10.75ZM15 10.75C15 10.3358 14.6642 10 14.25 10 13.8358 10 13.5 10.3358 13.5 10.75V16.25C13.5 16.6642 13.8358 17 14.25 17 14.6642 17 15 16.6642 15 16.25V10.75Z"
  })));
};

export { SvgBinMid as ReactComponent };
//# sourceMappingURL=bin-mid.svg.js.map
